// extracted by mini-css-extract-plugin
export var blue = "_1x-g";
export var brand = "_1x-c";
export var darkGrey = "_1x-f";
export var disabled = "_1x-5";
export var disabledSubtle = "_1x-6";
export var error = "_1x-7";
export var green = "_1x-h";
export var grey = "_1x-e";
export var icon = "_1x-0";
export var inherit = "_1x-b";
export var lightGrey = "_1x-d";
export var orange = "_1x-j";
export var pink = "_1x-l";
export var primary = "_1x-1";
export var purple = "_1x-m";
export var quaternary = "_1x-4";
export var red = "_1x-k";
export var secondary = "_1x-2";
export var success = "_1x-a";
export var tertiary = "_1x-3";
export var warning = "_1x-8";
export var warningSecondary = "_1x-9";
export var white = "_1x-n";
export var yellow = "_1x-i";